import React, { useEffect, useState, useRef } from "react";
// import moment from "moment-timezone";
import "../../../styles/live-subscriptions/membership-notification.css";
import { convertThenFormat } from "../../common-data/Converts";
// import notificationSound from "../../../assets/sounds/new_membership.mp3";
import notificationSound from "../../../assets/vocal-sound/vocal_new_subscription.mp3";
import {
  // CalenderIcon1,
  // CallIcon,
  // LocationIcon1,
  // PersonIcon,
  RupeeIcon,
} from "../../../images/icons/icons";
import MemberBasicInfo from "../MemberBasicInfo";
import ToaserInfo from "../ToaserInfo";
import FooterTags from "../FooterTags";

const SubscriptionWebhook = ({ userInfoData, setStatsData, setAllDatas }) => {
  const audioRef = useRef(null);
  const wsRef = useRef(null);
  const wsBackoffRef = useRef(2000);
  const processedWebhookEvents = useRef(new Set());

  const [notifications, setNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

  const playNotificationSound = () => {
    try {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch((error) => {});
      }
    } catch (error) {}
  };

  const showMembershipNotification = (membershipData) => {
    console.log("membershipData=> ", membershipData);

    const eventId = `${membershipData?.member_name || ""}_${
      membershipData?.mobile || ""
    }_${membershipData?.purchase_date || ""}_${Date.now()}`;

    const now = Date.now();
    const existingEvent = Array.from(processedWebhookEvents.current).find(
      (item) => {
        const [id, timestamp] = item.split("_TIMESTAMP_");
        return (
          id.includes(membershipData?.member_name || "") &&
          id.includes(membershipData?.mobile || "") &&
          now - parseInt(timestamp) < 10000
        );
      }
    );

    if (existingEvent) {
      return;
    }

    const eventWithTimestamp = `${eventId}_TIMESTAMP_${now}`;
    processedWebhookEvents.current.add(eventWithTimestamp);

    processedWebhookEvents.current.forEach((item) => {
      const [, timestamp] = item.split("_TIMESTAMP_");
      if (now - parseInt(timestamp) > 30000) {
        processedWebhookEvents.current.delete(item);
      }
    });

    const notification = membershipData || {};
    // const notification = {
    //   id: membershipData?.id || Date.now() + Math.random(),
    //   user_id: membershipData?.user_id || "",
    //   purchase_date:
    //     membershipData?.purchase_date ||
    //     moment().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),
    //   gym_name: membershipData?.gym_name || "NA",
    //   name: membershipData?.name || membershipData?.member_name || "NA",
    //   mobile: membershipData?.mobile || "",
    //   start_date: membershipData?.start_date || "",
    //   expire_date: membershipData?.expire_date || "",
    //   plan_name: membershipData?.plan_name || "NA",
    //   three_day_assigned: membershipData?.three_day_assigned || null,
    //   three_day_id: membershipData?.three_day_id || null,
    //   handover_status: membershipData?.handover_status || "NA",
    //   type: membershipData?.type || "NA",
    //   price: membershipData?.price || 0,
    //   is_partial: membershipData?.is_partial || null,
    //   bca_report: membershipData?.bca_report || "NA",
    //   assigned_date: membershipData?.assigned_date || "NA",
    //   timestamp: Date.now(),
    //   date_added:
    //     membershipData?.date_added ||
    //     moment().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),
    // };

    // setNotifications((prev) => [...prev, notification]);
    setNotifications((prev) => {
      const newNotifications = [notification, ...prev];

      return newNotifications;
    });
    playNotificationSound();

    if (setStatsData) {
      setStatsData((prev) => {
        const currentTotal = Number(prev.total) || 0;
        const currentRegular = Number(prev.regular_subscriptions) || 0;
        const currentPT = Number(prev.personal_training) || 0;

        const isPersonalTraining =
          membershipData?.type === "addont_pt" || membershipData?.type === "pt";

        return {
          ...prev,
          total: currentTotal + 1,
          regular_subscriptions: isPersonalTraining
            ? currentRegular
            : currentRegular + 1,
          personal_training: isPersonalTraining ? currentPT + 1 : currentPT,
        };
      });
    }

    if (setAllDatas) {
      setAllDatas((prev) => ({
        ...prev,
        allData: [notification, ...prev.allData],
      }));
    }

    // setTimeout(() => {
    //   setNotifications((prev) => prev.filter((n) => n.id !== notification.id));
    // }, 95000);
    setTimeout(() => {
      setNotifications((prev) => {
        const updated = prev.filter((n) => n.id !== notification.id);
        if (activeTab >= updated.length && updated.length > 0) {
          setActiveTab(updated.length - 1);
        }
        return updated;
      });
    }, 95000);
  };

  useEffect(() => {
    const WS_URL = process.env.REACT_APP_ODM_WSS_URL;
    if (!WS_URL || !userInfoData || isIOS()) return;

    let stopped = false;

    const computeChannels = () => {
      try {
        const acc = userInfoData?.account_type;
        const channels = [];

        if (acc === "receptionist" && userInfoData?.gym_id) {
          channels.push(`membership:gym:${userInfoData.gym_id}`);
        }
        if (acc === "cluster_manager") {
          const userGyms = userInfoData?.gyms?.gyms || userInfoData?.gyms || [];
          if (Array.isArray(userGyms)) {
            userGyms.forEach((g) => {
              const gid = g?.value || g?.gym_id || g?.uid || g;
              if (gid) channels.push(`membership:gym:${gid}`);
            });
          }
        }
        if (acc === "admin") {
          channels.push("membership:global");
        }

        return Array.from(new Set(channels));
      } catch {
        return [];
      }
    };

    const connect = () => {
      if (stopped) return;
      try {
        const token = encodeURIComponent(userInfoData?.token || "");
        const ws = new WebSocket(`${WS_URL}?token=${token}&type=membership`);
        wsRef.current = ws;

        ws.onopen = () => {
          wsBackoffRef.current = 2000;
          const channels = computeChannels();

          try {
            ws.send(
              JSON.stringify({
                type: "SUBSCRIBE",
                channels: channels,
                event_filter: ["new_membership"],
              })
            );
          } catch (e) {}
        };

        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);

            if (
              msg?.event_type === "new_membership" &&
              msg?.data &&
              msg?.message
            ) {
              showMembershipNotification(msg.data);
            } else {
            }
          } catch (err) {}
        };

        ws.onclose = () => {
          if (stopped) return;
          const delay = Math.min(wsBackoffRef.current, 30000);
          setTimeout(connect, delay);
          wsBackoffRef.current = Math.min(wsBackoffRef.current * 2, 30000);
        };

        ws.onerror = () => {
          try {
            ws.close();
          } catch {}
        };
      } catch {
        const delay = Math.min(wsBackoffRef.current, 30000);
        setTimeout(connect, delay);
        wsBackoffRef.current = Math.min(wsBackoffRef.current * 2, 30000);
      }
    };

    connect();

    return () => {
      stopped = true;
      try {
        if (wsRef.current && wsRef.current.readyState === 1) {
          wsRef.current.close();
        }
      } catch {}
    };
  }, [userInfoData]);

  useEffect(() => {
    if (audioRef.current) {
      const audio = audioRef.current;

      audio.addEventListener("loadstart", () => {});

      audio.addEventListener("canplay", () => {});

      audio.addEventListener("canplaythrough", () => {});

      audio.addEventListener("error", (e) => {});

      audio.load();
    }
  }, []);

  useEffect(() => {
    if (notifications.length > 0) {
      setActiveTab(0);
    }
  }, [notifications.length]);

  // const testAudio = () => {
  //   if (audioRef.current) {
  //     audioRef.current.currentTime = 0;
  //     audioRef.current
  //       .play()
  //       .then(() => {})
  //       .catch((error) => {});
  //   }
  // };

  return (
    <>
      <audio
        ref={audioRef}
        preload="auto"
        src={notificationSound}
        style={{ display: "none" }}
      />

      {/* <button
        onClick={testAudio}
        style={{
          position: "fixed",
          top: "10px",
          left: "10px",
          zIndex: 10000,
          padding: "10px",
          background: "red",
          color: "white",
          border: "none",
        }}
      >
        🔊 Test Audio
      </button> */}

      {notifications.length > 0 && (
        <div className="live-subscription-membership-notifications-container">
          <div className="live-subscription-feed-modal">
            <div className="live-subscription-modal-header">
              <div>
                <h2 className="live-subscription-modal-title">
                  Live Subscription Feed
                </h2>
                <p className="live-subscription-active-count">
                  {notifications.length} Active Subscriptions
                </p>
              </div>
              <button
                className="live-subscription-close-modal-btn"
                onClick={() => setNotifications([])}
              >
                ×
              </button>
            </div>

            <div className="live-subscription-tab-navigation">
              {notifications.map((notification, index) => {
                return (
                  <button
                    key={notification.id}
                    className={`live-subscription-tab-item ${
                      index === activeTab ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(index)}
                  >
                    #{index + 1}
                  </button>
                );
              })}
            </div>

            {notifications[activeTab] && (
              <div className="live-subscription-membership-notification-card">
                {/* <div className="live-subscription-member-info-section">
                  <div className="live-subscription-member-basic-info">
                    <div className="live-subscription-member-name">
                      <PersonIcon />
                      {notifications[activeTab]?.name || "NA"}
                    </div>
                    <div className="live-subscription-member-phone">
                      <CallIcon />
                      {notifications[activeTab]?.mobile || "NA"}
                    </div>
                    <div className="live-subscription-gym-location">
                      <LocationIcon1 />
                      {notifications[activeTab]?.gym_name || "NA"}
                    </div>
                  </div>
                </div> */}
                <MemberBasicInfo
                  rowData={notifications[activeTab]}
                  customTitle="New Subscription"
                />

                <ToaserInfo
                  from="new_subscription"
                  rowData={notifications[activeTab]}
                />

                {/* <div className="live-subscription-subscription-details">
                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">
                      Purchase
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.purchase_date || "-"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">Start</div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.start_date || "-"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">
                      Expires
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.expire_date || "-"}
                    </div>
                  </div>
                </div> */}

                <div className="live-subscription-total-amount-section">
                  <div className="live-subscription-total-amount-label">
                    <RupeeIcon />
                    Total Amount
                  </div>
                  <div className="live-subscription-total-amount-value">
                    ₹{convertThenFormat(notifications[activeTab]?.price || 0)}
                  </div>
                </div>

                <FooterTags
                  from="new_subscription"
                  rowData={notifications[activeTab]}
                />
                {/* <div className="live-subscription-membership-badges">
                  <div
                    className={`live-subscription-membership-badge ${notifications[activeTab].type}`}
                  >
                    {notifications[activeTab]?.type === "addont_pt"
                      ? "Personal Training"
                      : "Regular"}
                  </div>
                  <div className="live-subscription-membership-badge plan">
                    {notifications[activeTab]?.plan_name || "NA"}
                  </div>
                </div> */}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionWebhook;
